// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MagIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21">
            <path
                fill="currentColor"
                d="M19.6914065,18.3984375 L14.4570315,13.1640625 C15.589844,11.7773438 16.25,10.0312495 16.25,8.125 C16.25,3.63789082 12.613281,0 8.125,0 C3.63671899,0 0,3.63789082 0,8.125 C0,12.6121092 3.63789082,16.25 8.1250006,16.25 C10.0308603,16.25 11.779297,15.589453 13.1640631,14.4906247 L18.3984381,19.7249997 C18.5820323,19.9101567 18.8242191,20 19.0625006,20 C19.3007821,20 19.542188,19.9084377 19.7253913,19.7253513 C20.0898439,19.3593752 20.0898439,18.7656248 19.6914071,18.3984375 L19.6914065,18.3984375 Z M8.1250006,14.375 C4.6789068,14.375 1.8750006,11.5710938 1.8750006,8.125 C1.8750006,4.6789062 4.6789068,1.875 8.1250006,1.875 C11.5710944,1.875 14.3750006,4.6789062 14.3750006,8.125 C14.3750006,11.5710938 11.5703136,14.375 8.1250006,14.375 Z M11.2500006,7.1875 L9.02734458,7.1875 L9.02734458,5 C9.02734458,4.48203087 8.60781312,4.0625 8.1250006,4.0625 C7.64218807,4.0625 7.1875006,4.48046923 7.1875006,5 L7.1875006,7.1875 L4.96484399,7.1875 C4.48046863,7.1875 4.0625,7.60546863 4.0625,8.125 C4.0625,8.64453137 4.48164046,9.0625 4.96484399,9.0625 L7.1875006,9.0625 L7.1875006,11.25 C7.1875006,11.7679691 7.60664105,12.1875 8.08984458,12.1875 C8.60781312,12.1875 8.99218857,11.7679691 8.99218857,11.25 L8.99218857,9.0625 L11.1796886,9.0625 C11.7695314,9.0625 12.1875006,8.64453137 12.1875006,8.125 C12.1875006,7.60546863 11.7695314,7.1875 11.2500006,7.1875 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(MagIcon);
